(() => {
  const root = document.querySelector('.saza-ad--ugc');
  if (!root || root.dataset.reviewsReady) return;
  root.dataset.reviewsReady = 'true';
  const dialog = root.querySelector('.saza-reviews-dialog');
  if (!dialog) return;
  const player = dialog.querySelector('.saza-reviews-player');
  let opener;
  root.querySelectorAll('[data-tiktok-id]').forEach(button => button.addEventListener('click', () => {
    opener = button;
    const frame = document.createElement('iframe');
    frame.src = `https://www.tiktok.com/player/v1/${button.dataset.tiktokId}?autoplay=1`;
    frame.title = `Charming Blue video by ${button.dataset.creator}`;
    frame.allow = 'autoplay; fullscreen';
    frame.allowFullscreen = true;
    player.replaceChildren(frame);
    dialog.querySelector('.saza-reviews-fallback').href = `https://www.tiktok.com/@${button.dataset.creator}/video/${button.dataset.tiktokId}`;
    dialog.showModal();
  }));
  dialog.querySelector('.saza-reviews-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => { player.replaceChildren(); opener?.focus(); });
})();
